var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundRelease({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 57,
    viewBox: "0 0 66 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 57,
    rx: 12,
    fill: "#FEC10D",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3335 37.3333V40H43.6668V21.3333L33.0002 16L22.3335 21.3333V24",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3335 37.3333V40H43.6668V21.3333L33.0002 16L22.3335 21.3333V24",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3335 30.6667H22.3335",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3335 30.6667H22.3335",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 26.6641L22.3335 30.6641L26.3335 34.6641",
    stroke: "#FEC10D",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 26.6641L22.3335 30.6641L26.3335 34.6641",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundRelease);
export default __webpack_public_path__ + "static/media/fund_release.0c3a42791ed93c891a6d63333c7a4544.svg";
export { ForwardRef as ReactComponent };